var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all-chart"},[_c('div',{staticClass:"chart-holder charts-holder"},[_c('canvas',{attrs:{"id":"myChart","height":"300"}}),(_vm.convertedLabels.length <= 0)?_c('span',{staticClass:"no-data"},[_vm._v(" "+_vm._s(_vm.$t("common.no_data"))+" ")]):_vm._e()]),_c('div',{staticClass:"legend-container",attrs:{"id":"legend-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }